import { render, staticRenderFns } from "./custom-page.component.vue?vue&type=template&id=2a10562e&"
import script from "./custom-page.component.ts?vue&type=script&lang=js&"
export * from "./custom-page.component.ts?vue&type=script&lang=js&"
import style0 from "./custom-page.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports